import React from 'react'

import TextField from '@galo-monitor/web-components/TextField'

const InputText = (props) => <TextField { ...props } type="text" />

export default InputText
